export default __webpack_public_path__ + "static/media/logo-viva-saude.0c59d070.png";